<template>
  <div class="h-full">
    <a-table :columns="columns" :data-source="dataAbsence" :loading="loading" size="small" :pagination="false" bordered
      class="mb-20">
      <template slot="detail" slot-scope="text, record">
        <h6>
          <img :src="record.icon" width="35" class="mr-10" alt="imag_overview_1" />{{ record.toppic }}
        </h6>
      </template>
      <template slot="info" slot-scope="text, record">
        <a-popover placement="bottom">
          <template slot="content">
            <span class="text-justify font-web" v-html="record.desc"></span>
          </template>
          <template slot="title">
            <span><strong>Info</strong></span>
          </template>
          <a-icon theme="twoTone" two-tone-color="#4c7ee8" type="info-circle" />
        </a-popover>
      </template>
      <template slot="usedleave" slot-scope="text, record">
        <h6 :class="{ 'text-muted': record.used === 'N/A' || record.used == 0 }">
          {{ record.used }}
        </h6>
      </template>
      <template slot="usedleaveleft" slot-scope="text, record">
        <div v-if="!['', 'N/A', '-'].includes(record.used) && !['', 'N/A', '-'].includes(record.limit)">
          <span v-if="record.index !== 5">{{ parseFloat(record.limit) - parseFloat(record.used) }}</span>
          <span v-else>
            {{ parseFloat(dataQuota['casual_quota']) - parseFloat(record.used) }}
          </span>
        </div>
        <div v-else>-</div>
      </template>
      <template slot="limit" slot-scope="text, record">
        <span v-if="record.index === 5" class="text-center text-muted">
          {{ dataQuota['casual_quota'] }}
        </span>
        <span v-else class="text-center text-muted">{{ record.limit }}</span>
      </template>
      <template slot="footer" slot-scope="currentPageData">
        <small class="text-muted">
          Read more notices about the requirements for each type of leave.
          <a class="ml-5" target="_blank"
            href="https://drive.google.com/file/d/17zqcS6zDJ1nDnEMjRJJLOPqaU_k-lGvR/view?usp=sharing">Click Here</a>
        </small>
        <br>
        <small class="text-muted">
          If you have questions, please do not hesitate to contact me by this
          email
          <a href="mailto:yanin.som@mahidol.ac.th">yanin.som@mahidol.ac.th</a>
        </small>
      </template>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    title: "Detail",
    dataIndex: "detail",
    scopedSlots: { customRender: "detail" },
  },
  {
    title: "Available leave days (จำนวนวันที่ใช้ลาได้)",
    dataIndex: "limit",
    scopedSlots: { customRender: "limit" },
    width: "30%",
    className: "text-center font-web",
  },
  {
    title: "Spent leave (ใช้วันลาไปแล้ว)",
    dataIndex: "usedleave",
    scopedSlots: { customRender: "usedleave" },
    width: "20%",
    className: "text-center column-b font-web",
  },
  {
    title: "Remaining leave (วันลาที่เหลือ)",
    dataIndex: "usedleaveleft",
    scopedSlots: { customRender: "usedleaveleft" },
    width: "20%",
    className: "text-center column-a font-web",
  },
  {
    title: "Info",
    dataIndex: "info",
    scopedSlots: { customRender: "info" },
    className: "text-center",
  },
];
import desc from "./desc.js";
export default {
  props: {
    FiscalYear: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      columns,
      dataAbsence: [
        {
          index: 1,
          icon: "../../images/holiday-icon.png",
          toppic: "Vacation leave",
          desc: desc.items[0].content_1,
          used: "",
          limit: "",
        },
        {
          index: 2,
          icon: "../../images/sick-icon-1.png",
          toppic: "Sick leave",
          desc: desc.items[0].content_2,
          used: "",
          limit: "60",
        },
        {
          index: 3,
          icon: "../../images/sick-icon.png",
          toppic: "Medical Leave",
          desc: desc.items[0].content_3,
          used: "",
          limit: "120",
        },
        {
          index: 4,
          icon: "../../images/extra-icon-other.png",
          toppic: "Extra Leave",
          desc: desc.items[0].content_4,
          used: "",
          limit: "-",
        },
        {
          index: 5,
          icon: "../../images/leave-icon.png",
          toppic: "Casual leave",
          desc: desc.items[0].content_5,
          used: "",
          limit: "10 *",
        },
        {
          index: 6,
          icon: "../../images/mook-icon.png",
          toppic: "Monkhood leave",
          desc: desc.items[0].content_6,
          used: "",
          limit: "-",
        },
        {
          index: 7,
          icon: "../../images/maternity-icon.png",
          toppic: "Maternity leave",
          desc: desc.items[0].content_7,
          used: "",
          limit: "-",
        },
        {
          index: 8,
          icon: "../../images/extra-icon.png",
          toppic: "Other leave",
          desc: desc.items[0].content_8,
          used: "",
          limit: "-",
        },
        {
          index: 9,
          icon: "../../images/sick-icon.png",
          toppic: "Long Term Medical",
          desc: '',
          used: "",
          limit: "-",
        },
      ],
      // dataQuota
      dataQuota: {},
      // 
      loading: false,
    };
  },
  watch: {
    FiscalYear(val) {
      this.getQuota();
      this.getAbsence();
      this.getDataLimitLeave();
    },
  },
  mounted() {
    this.getQuota();
    this.getAbsence();
    this.getDataLimitLeave()
  },
  methods: {
    async getAbsence() {
      this.loading = true;
      try {
        const res = await this.$http.get(
          `/hri/leave_of_absence/summary_absence/?year=${this.FiscalYear}`
        );
        if (res.status === 200) {
          this.dataAbsence[0].used = res.data.vacation;
          this.dataAbsence[1].used = res.data.sick;
          this.dataAbsence[2].used = res.data.medical;
          this.dataAbsence[3].used = res.data.extra;
          this.dataAbsence[4].used = res.data.casual;
          this.dataAbsence[5].used = res.data.monkhood;
          this.dataAbsence[6].used = res.data.maternity;
          this.dataAbsence[7].used = res.data.other;
          this.dataAbsence[8].used = res.data.long_term_medical;
          this.loading = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.loading = false;
        this.dataAbsence[0].used = "N/A";
        this.dataAbsence[1].used = "N/A";
        this.dataAbsence[2].used = "N/A";
        this.dataAbsence[3].used = "N/A";
        this.dataAbsence[4].used = "N/A";
        this.dataAbsence[5].used = "N/A";
        this.dataAbsence[6].used = "N/A";
        this.dataAbsence[7].used = "N/A";
      }
    },
    async getDataLimitLeave() {
      try {
        const resLimit = await this.$http.get(
          `/hri/vacation_quota/?year=${this.FiscalYear}`
        );
        if (resLimit.status === 200) {
          this.dataAbsence[0].limit = resLimit.data[0].quota;
        } else {
          const error = new Error('Request Failed');
          error.resLimit = resLimit;
          error.response = resLimit;
          throw error;
        }
      } catch (error) {
        this.dataAbsence[0].limit = "N/A";
      }
    },
    async getQuota() {
      try {
        const res = await this.$http.get(`/hri/vacation_quota/casual/?year=${this.FiscalYear}`);
        if (res.status === 200) {
          this.dataQuota = Object.assign({}, res.data)
        }
        else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.dataQuota = Object.assign({}, { 'casual_quota': 0 })
      }
    }
  },
};
</script>


<style>
th.column-a {
  background-color: #87b9fa !important;
  color: #000 !important;
  text-align: 'center' !important;
}

td.column-a {
  background-color: #cfe2fb !important;
  color: #000 !important;
  text-align: 'center' !important;
  font-weight: 900;
}

th.column-b {
  background-color: #fe9393 !important;
  color: #000 !important;
  text-align: 'center' !important;
}

td.column-b {
  background-color: #ffd5d5 !important;
  color: #000 !important;
  text-align: 'center' !important;
  font-weight: 900;
}
</style>